import { z } from 'zod'

export const schema = z.object({})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  userType: z.enum(['TRAVELER', 'OWNER', 'EMPLOYEE']),
  firstName: z.string(),
  lastName: z.string().nullable(),
  phone: z.string().nullable(),
  provinceId: z.number().int().nullable(),
  emailAddress: z.string(),
  emailAddressRepeat: z.string(),
  facebookId: z.string().nullable(),
  googleId: z.string().nullable(),
  appleId: z.string().nullable(),
  password: z.string().nullable(),
  recaptcha: z.string(),
  signUpOrigin: z.string(),
  allowComms: z.boolean(),
  privacyPolicy: z.boolean(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
